var __assign = this && this.__assign || Object.assign || function (t) {
  for (var s, i = 1, n = arguments.length; i < n; i++) {
    s = arguments[i];

    for (var p in s) {
      if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
  }

  return t;
};

import * as React from 'react';
import ConfigurationComponent from './../base/ConfigurationComponent';

var ChartNavigatorPane = function ChartNavigatorPane(props) {
  return React.createElement(ConfigurationComponent, __assign({}, props, {
    _chartKey: "pane"
  }));
};

ChartNavigatorPane.displayName = 'ChartNavigatorPane';
export default ChartNavigatorPane;